import { Artikel } from "../../../formular-model/formular-groups/interfaces/FormularGroupArtikel";

export interface ItemRequest {
  state: "new" | "edit";
  data: Artikel | null;
  actions: { label: string; value: string | number | null }[];
}
export interface ItemResult {
  state: boolean;
  data: Artikel | null;
}

export const EINHEITEN = [
  { label: "Stück", value: "St." },
  { label: "Pauschale", value: "pausch." },
  { label: "Liter", value: "l" },
  { label: "Milliliter", value: "ml" },
  { label: "Meter", value: "m" },
  { label: "Zentimeter", value: "cm" },
  { label: "Millimeter", value: "mm" },
  { label: "Tonne", value: "t" },
  { label: "Kilogram", value: "kg" },
  { label: "Gramm", value: "gr" },
  { label: "Tag(e)", value: "Tag(e)" },
  { label: "Stunden", value: "Std." },
  { label: "Minuten", value: "min" },
] as const;

export type EinheitValue = (typeof EINHEITEN)[number]["value"];